import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../api/services/common.service';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { getAvatarBgColor } from '../../../helpers/avatar.helper';
import { InitialsService } from '../../../helpers/initial.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-search-list',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './search-list.component.html',
  styleUrl: './search-list.component.css',
})
export class SearchListComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  @Input() autoFocused: any;
  endpoint = environment.api_endpoint;
  fieldsData: any[] = [];
  showError: string = '';
  showErrors: boolean = false;
  userLoading: { [userId: string]: boolean } = {};
  allFieldsData: any;
  isLoading: boolean = true;
  formId: any;
  constructor(
    private formService: FormsServiceService,
    private commonService: CommonService,
    private toaster: ToastrService,
    private initialsService: InitialsService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    this.getData();
    const control = this.formGroup.get(this.fields.fieldName);
    if (control) {
      control.valueChanges.subscribe(() => {
        this.validateSelection();
        this.cdr.detectChanges();
      });
    }
  }

  ngOnChanges() {
    if (!this.autoFocused) return;

    setTimeout(() => {
      this.searchInput?.nativeElement.focus();
    });
  }
  /** Function to get the data by api or static */
  getData() {
    if (this.fields.options.isStatic == false) {
      this.fieldsData = this.fields.options.staticOptions;
    } else {
      this.formId = this.fields.options.source.formID;
      const api_endpoint = this.endpoint;
      const method = this.fields.options.source.method;
      let url = this.fields.options.source.apiUrl;
      const replacements = {
        formID: this.formId,
        api_endpoint: api_endpoint,
      };

      url = this.formService.replaceTemplateTokens(url, replacements);
      const headers = {
        'Content-Type': 'application/json',
      };
      this.formService.loadData(method, url, headers).subscribe({
        next: (res) => {
          this.fieldsData = res.data.records || [];
          // this.applyFilters('');
          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.isLoading = false;
          this.cdr.detectChanges();
        },
      });
    }
    // this.applyFilters('');
  }

  applyFilters(searchText: string) {
    this.fieldsData = [...this.allFieldsData];
  }

  onKeyUpSearch(searchInput: any) {
    // this.formId = FORM_ID.USERS;
    if (searchInput.length >= 3 || searchInput.length === 0) {
      this.loadData(this.formId, { query: searchInput });
    }
  }

  loadData(formId: any, pagination: { query: string } = { query: '' }) {
    this.isLoading = true;
    this.commonService.loadListWithOptions(formId, pagination).subscribe({
      next: (data) => {
        this.allFieldsData = data.data.records || [];
        this.applyFilters(pagination.query);
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.fieldsData = [];
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });
  }

  /** Show color for the user department wise */
  getBgColorByDepartment(name: string): string {
    return getAvatarBgColor(name);
  }

  getInitials(name: string): string {
    return this.initialsService.getInitials(name);
  }

  resetSearch(): void {
    // const formId = FORM_ID.USERS;
    this.searchInput.nativeElement.value = '';
    this.loadData(this.formId, { query: '' });
    const control = this.formGroup?.get(this.fields.fieldName);
    if (control) {
      control.setValue(null);
      control.markAsPristine();
      control.markAsUntouched();
      control.updateValueAndValidity();
    }
    this.showError = '';
  }

  validateSelection(): boolean {
    const control = this.formGroup.get(this.fields.fieldName);
    if (!control?.value) {
      this.showError = 'Please select user';
      control?.setErrors({ required: true });
      return false;
    } else {
      this.showError = '';
      control?.setErrors(null);
      return true;
    }
  }

  /** Invite user with the details */
  inviteUser(item: any) {
    this.userLoading[item._id] = true;
    const payload = {
      fullName: item.name,
      email: item.email,
      invite: 'SENT',
      status: 'ACTIVE',
    };

    this.commonService.updateUserStatus(payload).subscribe({
      next: (res: any) => {
        this.toaster.success(res.message, 'Success', {
          messageClass: 'addMessage',
          titleClass: 'addCss',
        });
        this.userLoading[item._id] = false;
        setTimeout(() => {
          this.getData();
        }, 200);
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.toaster.error(err.message, 'Error', {
          messageClass: 'addMessage',
          titleClass: 'addCss',
        });
        this.cdr.detectChanges();
      },
    });
  }

  selectOption(option: any, event: MouseEvent) {
    if (option.status !== 'ACTIVE') return;

    const selection = window.getSelection()?.toString();
    if (selection && selection.length > 0) return;

    const control = this.formGroup.get(this.fields.fieldName);

    if (!control) return;

    control.setValue({
      email: option.email,
      name: option.name,
      _id: option._id,
    });

    // ✅ Important: mark properly
    control.markAsDirty();
    control.markAsTouched();
    control.updateValueAndValidity();
  }
}
